module.exports = "https://static.web-explore.prod.moonpig.net/_next/static/images/logo-square-0280c706edcf2c9a3ca2f48466900209.png";